import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import AssetDataProcessingDefinitionList from '../../../../modules/dataprocessingdefinitions/AssetDataProcessingDefinitionList';
import createRoute from './create/routes';
import editRoute from './edit/routes';

import IconCalculator from '../../../../assets/icon_data.svg?react';
import {AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION} from '../../../../modules/common/consts';

export default {
	relativePath: 'dataprocessingdefinitions',
	label: {
		id: 'assets.detail.dataProcessingDefinition.title',
		defaultValue: 'KPI/Data Processing'
	},
	component: AssetDataProcessingDefinitionList,
	iconSvg: IconCalculator,
	childRoutes: [createRoute, editRoute],
	requiredAuthorities: [AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION]
} satisfies RouteConfig;
